import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Ability, subject } from '@casl/ability';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { dailyReport } from '../../../../../../../../core/projects.selectors';
import { clearLocationControls } from '../../../../../../../../../../shared/helpers/design-context';

@Component({
    selector: 'app-internal-test-details-form',
    templateUrl: './internal-test-details-form.component.html',
    styleUrls: ['../../input-component-styles.scss',
        './internal-test-details-form.component.scss'],
    standalone: false
})
export class InternalTestDetailsFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() form: FormGroup = new FormGroup({});
  @Input() fields: any[] = [];
  @Input() selectedMediaFiles: any[] = [];
  @Output() onDeletePicture: EventEmitter<void> = new EventEmitter();
  errorMessages = {};
  warningMessages = {};
  /** Whether the report can be edited (same CASL check as the other daily-report editors): gates the location card. */
  editable = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();
  private readonly store = inject(Store);
  private readonly ability = inject(Ability);

  constructor(private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.store.select(dailyReport)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(report => {
        this.editable = this.ability.can('create', subject('DailyReport', { ...report }));
      });

    this.form.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        () => {
          this.validateForm();
        },
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    this.validateForm();
    this.cdRef.detectChanges();
  }

  deletePicture(id) {
    this.onDeletePicture.emit(id);
  }

  deleteLocation() {
    clearLocationControls(this.form);
  }

  showLocationSection() {
    return this.form?.controls?.latitude?.value !== null &&
      this.form?.controls?.longitude?.value !== null &&
      this.form?.controls?.latitude?.value !== '' &&
      this.form?.controls?.longitude?.value !== '';
  }

  validateForm() {
    this.errorMessages = {};
    this.warningMessages = {};

    for (const key in this.form.controls) {
      if (this.form.controls[key]?.errors) {
        if (this.form.controls[key]?.errors.required) {
          this.errorMessages[key] = 'Required';
        } else if (this.form.controls[key]?.errors.min) {
          this.errorMessages[key] = `Min: ${this.form.controls[key]?.['validation_rules'].min}`;
        } else if (this.form.controls[key]?.errors.max) {
          this.errorMessages[key] = `Max: ${this.form.controls[key]?.['validation_rules'].max}`;
        }
      }
    }

    this.fields.forEach(field => {
      const formField = this.form.get(field.id);
      const warningRules = formField?.['warning_rules'];

      if (formField.value && warningRules) {
        const value = Number(formField.value);
        const { min, max } = warningRules;

        const isBelowMin = min != null && value < min;
        const isAboveMax = max != null && value > max;

        if (isBelowMin || isAboveMax) {
          const messages = [];
          if (isBelowMin) {
            messages.push(`Min ${min}`);
          }
          if (isAboveMax) {
            messages.push(`Max ${max}`);
          }
          this.warningMessages[field.id] = `Range: ${messages.join(', ')}`;
        }
      }

    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
